import React from 'react';
import { useIntl, defineMessages } from 'react-intl';
import { connect, useDispatch } from 'react-redux';

import { MenuItem, ListItemIcon, ListItemText } from '@material-ui/core';

import { WithAuthorization } from '../../../authorization';
import { lowerRaisedHand } from '../../../lib/actions/room';
import { logEvent, Event } from '../../../lib/analytics';
import { UserActionsContext } from '../../../lib/contexts';
import { IconAcknowledgeState } from '../../IconSet';

import { mapStateToProps, MappedProps } from './mapState';


const messages = defineMessages({
  clearState: { id: 'clearStateIconButtonTooltip' },
});


function RaisedHandButton(props: ExtendedProps) {
  const {
    mySelf,
    amModerator,
    iconSize = 20,
    isScreen,
    uid,
    onClose,
    hasRaisedHand
  } = props;

  const { formatMessage } = useIntl();
  const dispatch = useDispatch();
  const userActionsContext = React.useContext(UserActionsContext);

  const lowerHand = React.useCallback(
    () => {
      if (mySelf) {
        return;
      }
      else {
        dispatch(lowerRaisedHand(uid));
        logEvent(Event.RESET_USER_STATE, { 'state': 'hand_raised', 'from': userActionsContext });
      }
      onClose();
    }
    , [dispatch, uid, mySelf, onClose, userActionsContext]
  );

  const disabled = (!amModerator && !mySelf) || isScreen;

  if (disabled || !hasRaisedHand) {
    return null;
  }

  return (
    <MenuItem onClick={lowerHand}>
      <ListItemIcon>
        <IconAcknowledgeState size={iconSize} />
      </ListItemIcon>
      <ListItemText primary={formatMessage(messages.clearState)} />
    </MenuItem>
  );
}


type Props = {
  uid: string;
  iconSize?: number;
  onClose: () => void;
}


type ExtendedProps = Props & MappedProps


const roles = ['room_owner', 'room_moderator'];

export default WithAuthorization(roles, connect(mapStateToProps)(RaisedHandButton));
